import styled from 'styled-components';

export const HoverImageWrapper = styled.div`
  background-color: ${({ theme }) => theme.baseBlue.a10};
  padding: 15px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    margin-top: 15px;
  }
`;

export const TextBox = styled.div`
  width: 410px;
  background-color: ${({ theme }) => theme.white.a1};
  text-align: center;
  padding: 15px;
  color: ${({ theme }) => theme.white.a10};
  font-size: 12px;
`;

export const HoverText = styled.span`
  margin-bottom: 15px;
`;

export const InfoIconBox = styled.div`
  width: 15px;
  height: 15px;
  &.icon-white {
    svg {
      color: ${({ theme }) => theme.white.a10};
    }
  }
`;
